import { createFileRoute } from '@tanstack/react-router'
import Trade from '@/features/trade'

export const Route = createFileRoute('/_authenticated/_sidebar/trade')({
	component: Trade,
})
